import React from 'react'
import Market from '../../assets/icons/market-icon.svg'
import { useState } from 'react'
import { Icon, DatePicker } from '../common'
import { SelectionStore, MapStore } from '../../store'
import { observer } from 'mobx-react-lite'
import { useText } from '../../texts'
import QRCode from 'react-qr-code'

const Accept = observer(() => {
  const t = useText()
  const visits = SelectionStore.selectionVisits
  const [qr, setQr] = useState('')
  const [dates, setDates] = useState(new Array(visits.length).fill(new Date()))
  const changeDate = (date, i) => {
    let arr = [...dates]
    arr[i] = date
    setDates(arr)
  }
  const shoppersList = SelectionStore.selectedUsers
  const finishSelection = () => SelectionStore.finishSelection()
  const getMessege = (user) => {
    let message = `Hello,  ${user.firstName} This is your 4Service company)\nWe offer you to visit the:`

    visits.forEach((visit, i) => {
      let currentDate = new Date(dates[i])
      let endDate = new Date(dates[i])
      endDate.setDate(currentDate.getDate() + 2)
      let sD = currentDate.getDate()
      let eD = endDate.getDate()
      let startMonth = String(currentDate.getMonth() + 1)
      let endMonth = String(endDate.getMonth() + 1)
      let formattedDate = `${sD}.${
        startMonth.length == 2 ? startMonth : '0' + startMonth
      } - ${eD}.${endMonth.length == 2 ? endMonth : '0' + endMonth}`;
      message += `\n${visit.client} location at the address: ${visit.city}, ${
        visit.address
      }. 
      \nPayment for the visit/s ${
        visit.bonus ? visit.payRate + visit.bonus : visit.payRate
      } ${visit.currency}. Date ${formattedDate}.\n`
    })

    message += `\nHurry up and confirm. The offer is limited. Have a nice day!  With care, your 4Service.`
    return message
  }
  const copyText = (msg) => {
    return navigator.clipboard.writeText(msg)
  }
  const goToTelegram = async (user) => {
    let msg = getMessege(user)
    await copyText(msg)
    let phone = user.phone.includes('+') ? user.phone : `+${user.phone}`
    window.open(`https://t.me/${phone}`, '_blank')
  }
  const goToViber = async (user) => {
    let msg = getMessege(user)
    await copyText(msg)
    let phone = user.phone
    window.open(`viber://chat?number=+${phone}&draft=${msg}`, '_blank')
  }
  const goToWhatsApp = async (user) => {
    let msg = getMessege(user)
    await copyText(msg)
    let phone = user.phone
    // Remove + from phone
    phone = phone.replace('+', '')
    window.open(
      `https://api.WhatsApp.com/send?phone=${phone}&text=${msg}`,
      '_blank'
    )
  }
  const generateQr = (user, type) => {
    let msg = getMessege(user)
    let phone = user.phone

    switch (type) {
      case 'whatsapp':
        setQr(`https://api.WhatsApp.com/send?phone=${phone}&text=${msg}`)
        return
      case 'viber':
        setQr(`viber://chat?number=+${phone}&draft=${msg}`)
        return
      case 'telegram':
        setQr(`https://t.me/${phone}`)
        return
      default:
        return
    }
  }
  const getDisabledDays = (exception) => {
    if (!exception || !exception.banedDays) return []

    return exception.banedDays.split(' ').map((d) => ({
      year: new Date(d).getFullYear(),
      month: new Date(d).getMonth() + 1,
      day: new Date(d).getDate(),
    }))
  }
  const minimumDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate(),
  }
  const end = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1)
  const maximumDate = {
    year: end.getFullYear(),
    month: end.getMonth() + 1,
    day: end.getDay(),
  }
  return (
    <div className="accept-tab">
      <div className="filter-menu__title">{t('select-shoppers')}</div>

      <div className="filter-list">
        {visits.map((visit, i) => (
          <>
            <div className="filter-list__item">
              <div className="filter-list__item-top">
                <img
                  src={Market}
                  className="filter-list__avatar"
                  alt={visit.client}
                />
                <div>
                  <div className="filter-list__title">{visit.client}</div>
                  <div className="filter-list__price">
                    {visit.bonus ? visit.payRate + visit.bonus : visit.payRate}{' '}
                    {visit.currency}
                  </div>
                </div>
              </div>

              <div className="d-flex align-center">
                <span className="sm-text">{t('visit-date')}:</span>
                <DatePicker
                  type="flat"
                  value={dates[i]}
                  handle={(v) => changeDate(v, i)}
                  disabledDays={getDisabledDays(visit.exception)}
                  minimumDate={minimumDate}
                  maximumDate={maximumDate}
                />
              </div>
              <div className="sm-text">
                {visit.city}, {visit.address || '---'}
              </div>
            </div>
          </>
        ))}
      </div>

      <div className="filter__line"></div>

      {shoppersList.map((user) => (
        <div
          className="filter-checkbox-row"
          key={user.id}
          style={{ paddingTop: 0 }}
        >
          <span>{user.firstName + ' ' + user.lastName}</span>
          <div className="user-links">
            <Icon
              icon="info"
              size="1.5rem"
              onClick={() => {
                MapStore.setActiveMarker({ ...user, type: 'user' }, true)
              }}
            />
            <Icon
              icon="whatsapp"
              size="1.5rem"
              onMouseEnter={() => generateQr(user, 'whatsapp')}
              onClick={() => goToWhatsApp(user)}
            />
            <Icon
              icon="viber"
              size="1.5rem"
              onClick={() => goToViber(user)}
              onMouseEnter={() => generateQr(user, 'viber')}
            />
            <Icon
              icon="telegram"
              size="1.5rem"
              onMouseEnter={() => generateQr(user, 'telegram')}
              onClick={() => goToTelegram(user)}
            />
          </div>
          <div className="ml-auto">
            <b>{user.visitsCount}</b>
          </div>
        </div>
      ))}

      <div className="filter__line"></div>

      <div className="filter__qr">
        {qr && (
          <QRCode
            size={256}
            style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
            value={qr}
            viewBox={`0 0 128 128`}
          />
        )}
      </div>

      <div className="filter__line"></div>

      <div className="input-wrapper">
        <div className="input">
          <textarea
            name="message"
            id="message"
            className="input"
            value={SelectionStore.selectionMessage}
            placeholder="Текст сообщения"
            rows="9"
          ></textarea>
        </div>
      </div>
      <div className="filter-list__bottom">
        <button
          className="btn btn-secondary"
          onClick={() => {
            SelectionStore.prevTab()
          }}
        >
          {t('back')}
        </button>
        <button className="btn btn-primary" onClick={finishSelection}>
          {t('finish')}
        </button>
      </div>
    </div>
  )
})
export default Accept
